var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSerbia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50.8182C38.8071 50.8182 50 39.6253 50 25.8182C50 12.0111 38.8071 0.818176 25 0.818176C11.1929 0.818176 0 12.0111 0 25.8182C0 39.6253 11.1929 50.8182 25 50.8182Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0.818176C11.193 0.818176 0 12.0111 0 25.8182C0 28.8762 0.550098 31.8056 1.55498 34.5138H48.4451C49.45 31.8056 50 28.8762 50 25.8182C50 12.0111 38.807 0.818176 25 0.818176Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0.818176C14.2508 0.818176 5.08726 7.60255 1.55493 17.1226H48.4451C44.9126 7.60255 35.7491 0.818176 25 0.818176Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4646 14.9487V27.42C6.4646 34.5141 15.7323 36.6878 15.7323 36.6878C15.7323 36.6878 24.9999 34.5141 24.9999 27.42V14.9487H6.4646Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2974 17.1225H21.167V12.7747L18.9931 13.8616L15.7322 10.6008L12.4713 13.8616L10.2974 12.7747V17.1225Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.826 29.1564L15.7608 22.0911L8.69556 29.1564L11.0013 31.4621L15.7608 26.7026L20.5203 31.4621L22.826 29.1564Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.826 22.5573H19.5295C19.7149 22.2374 19.8227 21.8669 19.8227 21.4706C19.8227 20.2698 18.8494 19.2967 17.6488 19.2967C16.8192 19.2967 16.0988 19.7613 15.7323 20.4444C15.3658 19.7614 14.6454 19.2967 13.8158 19.2967C12.6152 19.2967 11.6418 20.2698 11.6418 21.4706C11.6418 21.8669 11.7497 22.2375 11.935 22.5573H8.69556C8.69556 23.758 9.74136 24.7313 10.9418 24.7313H10.8695C10.8695 25.9319 11.8427 26.9052 13.0434 26.9052C13.0434 27.9683 13.8069 28.8515 14.8152 29.0405L13.1023 32.9079C13.9232 33.2416 14.8203 33.427 15.7609 33.427C16.7015 33.427 17.5986 33.2416 18.4195 32.9079L16.7066 29.0405C17.7149 28.8517 18.4784 27.9684 18.4784 26.9052C19.6791 26.9052 20.6523 25.9319 20.6523 24.7313H20.5799C21.7803 24.7313 22.826 23.7579 22.826 22.5573Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.818176)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerbia);
export default __webpack_public_path__ + "static/media/serbia.9ad17750913d8f66ff571e87847ce7c8.svg";
export { ForwardRef as ReactComponent };